<sdps-divider variation="secondary"></sdps-divider>
<div [formGroup]="taxWithholdingsFormGroup">
    <div class="space-between">
        <span id="section-title">Source account tax withholding election</span>
    </div>

    <!-- Warning message for Conv distribution -->
    <mm-banners *ngIf="showAndSetConvDistributionWarning" [bannerText]="[convWarningText]" [shouldBoldTitleText]="true" [type]="'warning'"></mm-banners>
    <mm-banners *ngIf="showMassachusettsDistributionWarning || showMississippiEarlyDistributionWarning" [bannerText]="[stateTaxAttentionRequiredWarningMessage]" [type]="'warning'"></mm-banners>

    <!-- Warning message for Q and Comb distribution -->
    <mm-banners *ngIf="showAndSetZeroPercentDistributionWarning" [bannerText]="[zeroPercentWarningText]" [titleText]="zeroPercentTitleWarningText" [shouldBoldTitleText]="true" [type]="'warning'"></mm-banners>

    <!-- COMBINED FED AND STATE TAX ERROR -->
    <mm-banners *ngIf="taxWithholdingsFormGroup?.errors && !hasOnlyStateTaxError" [bannerText]="[fedAndStateTaxSumError]" [type]="'error'" data-testid="fed-and-state-tax-error"></mm-banners>

    <!-- NRA BANNER -->
    <mm-banners *ngIf="nraIndicator" [bannerText]="[nraText]" [type]="'information'"></mm-banners>

    <mm-banners *ngIf="hasInternationalFedTaxError" [bannerText]="[internationalFedTaxError]" [type]="'error'" data-testid="intl-fed-tax-error"></mm-banners>

    <div class="row" data-testid="positions-lots-table_disclaimerMessage">
        <p class="disclaimerMessageText">If you make any changes to the tax withholding elections on file for this
            account, you represent and warrant that you have permission and authority to designate your client's
            elections and understand the tax consequences.</p>
    </div>
    <div class="row">
        <!-- FED TAX -->
        <div class="tax-container">
            <div *ngIf="!nraIndicator" class="tax-percent" id="federal-percent">
                <!-- FEDERAL TAX LABEL -->
                <div id="federal-tax-label" data-testid="fed-tax-title" [class.error-text]="isFedTaxInvalid">Federal tax
                </div>
                <!-- FEDERAL TAX INPUT BOX -->
                <input type="text" formControlName="fedTaxPercent" (blur)="onFedTaxBlur()"
                    [class.is-invalid]="fedTaxPercent.invalid"
                    (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                    data-testid="fed-tax-input" maxlength="10">
                <!-- FEDERAL TAX ERROR -->
                <div *ngIf="fedTaxPercent.invalid && !hasInternationalFedTaxError" class="alert-text" data-testid="fed-tax-error">
                    {{fedTaxError}}
                </div>
            </div>
        </div>
        <!-- STATE TAX -->
        <div id="state-tax-container">
            <div class="tax-container">
                <div class="tax-percent" id="state-percent">
                    <!-- STATE TAX LABEL -->
                    <div id="state-tax-label" data-testid='state-tax-title' [class.error-text]="isStateTaxInvalid">
                        {{stateTaxLabel}}
                    </div>
                    <!-- STATE TAX INPUT -->
                    <input type="text" formControlName="stateTaxPercent" (blur)="onStateTaxBlur()"
                        [class.is-invalid]="stateTaxPercent.invalid"
                        (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                        data-testid="state-tax-input" maxlength="10">
                    <!-- STATE TAX ERROR -->
                    <div *ngIf="stateTaxPercent.invalid || hasMississippiStateTaxErrorText" class="alert-text" data-testid="state-tax-error">
                        {{stateTaxError}}
                    </div>
                </div>
            </div>
            <!-- VIEW STATE TAX INFORMATION LINK -->
            <div id="view-state-tax-info-link">
                <a href="https://www.schwab.com/resource/state-income-tax-withholding-information-for-individual-retirement-accounts"
                    target="_blank">View state tax information</a>
            </div>
        </div>
    </div>
    <div class="divider"></div>
</div>

